var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterMessagesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97 97",
    style: {
      enableBackground: "new 0 0 97 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st02{fill:#31E6E8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st02",
    d: "M93.88,25.34l-2.8,2.8l-4,4c-2,2-4.4,4-6.81,6.01c-4.62,3.79-9.58,7.14-14.81,10.01 c-5.26,2.98-11.17,4.63-17.22,4.8c-6.04-0.17-11.95-1.82-17.22-4.8c-5.42-2.77-10.52-6.13-15.21-10.01c-2.4-2-4.8-4-6.81-6.01l-4-4 c-0.7-1.02-1.5-1.96-2.4-2.8c-1.81,7.74-2.61,15.68-2.4,23.62C0.19,85.39,8.6,93,48.24,93s48.04-7.61,48.04-44.04 C96.49,41.02,95.69,33.08,93.88,25.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st02",
    d: "M89.07,18.53c0.4-0.4,0.8-0.8,1.2-0.8C84.27,7.72,71.46,4.92,48.24,4.92c-23.62,0-36.03,2.8-42.44,12.41 c0.4,0.4,0.8,0.4,1.2,0.8v0.4l0.8,0.8c1.02,0.99,1.96,2.06,2.8,3.2l0.8,0.8c2.8,2.4,6.01,5.61,9.61,8.41 c4.21,3.52,8.78,6.61,13.61,9.21c4.19,2.32,8.84,3.69,13.61,4c4.79-0.26,9.45-1.63,13.61-4c4.87-2.56,9.43-5.64,13.61-9.21 c3.6-3.2,6.81-6.01,9.21-8.41l0.8-0.8c1.2-1.2,2-2.4,2.8-3.2L89.07,18.53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMessagesActive);
export default __webpack_public_path__ + "static/media/FooterMessagesActive.c483034c650e10bcfb437e7dd517862b.svg";
export { ForwardRef as ReactComponent };